import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sendGetReq } from "../DAL/http";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';


const JobApplication = () => {
  let { jobId } = useParams();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [jobsApplicationList, setJobApplication] = useState(null);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 5,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: {
      name: { value: "", matchMode: "contains" },
      // 'country.name': { value: '', matchMode: 'contains' },
      email: { value: "", matchMode: "contains" },
      // 'representative.name': { value: '', matchMode: 'contains' }
    },
  });

  let networkTimeout = null;

  useEffect(() => {
    loadLazyData();
  }, [lazyState]);

  const loadLazyData = () => {
    setLoading(true);
    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }
    //imitate delay of a backend call
    debugger;
    console.log(jobId);

    networkTimeout = setTimeout(() => {
      if (jobId != undefined && jobId !== "") {
        sendGetReq(
          "job-applications/" +
          jobId +
          "/" +
          [lazyState.page] +
          "/" +
          [lazyState.rows]
        )
          .then((data) => {
            debugger;
            setTotalRecords(data.count);
            setJobApplication(data.list);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error getting all Users:", error);
          });
      } else {
        sendGetReq(
          "job-applications/" + [lazyState.page] + "/" + [lazyState.rows]
        )
          .then((data) => {
            debugger;
            setTotalRecords(data.count);
            setJobApplication(data.list);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error getting all Users:", error);
          });
      }
    }, Math.random() * 1000 + 250);
  };

  const onPage = (event) => {
    debugger;
    event.page = event.first;
    setlazyState(event);
  };

  const onSort = (event) => {
    setlazyState(event);
  };

  const onFilter = (event) => {
    event["first"] = 0;
    setlazyState(event);
  };


  const downloadFile = (rowData) => {
    debugger
    window.location.href = rowData.resume
  }


  const onButtonClick = (rowData) => {
    debugger
    //https://services.overseasitservices.com/resumes/1710411864872_Roja%20Resume%202024.docx
    //"https://services.overseasitservices.com/resumes/1710263076215_MUJAHID%20CV.pdf"
    const pdfUrl = "https://infolabs-bucket.nyc3.cdn.digitaloceanspaces.com/resumes/" + rowData.resume;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = rowData.resume; // specify the filename
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const actionBodyTemplate = (rowData) => {
    debugger
    return (
      <React.Fragment>
        <Button icon="pi pi-download" outlined className="mr-2" onClick={() => onButtonClick(rowData)}/>
      </React.Fragment>
    );
  };

  return (
    <>
      <h2 style={{ fontSize: "30px", color: "#0F172A", marginBottom: "30px" }}>All Job Applications</h2>

      <div class="card mb-4">
        <div class="card-body">
          <DataTable
            value={jobsApplicationList}
            lazy
            filterDisplay="row"
            key="{id}"
            paginator
            showGridlines
            first={lazyState.first}
            rows={5}
            totalRecords={totalRecords}
            onPage={onPage}
            rowsPerPageOptions={[10, 25, 50]}
            onSort={onSort}
            sortField={lazyState.sortField}
            sortOrder={lazyState.sortOrder}
            onFilter={onFilter}
            filters={lazyState.filters}
            loading={loading}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column field="fullName" header="Name" style={{ width: "300px" }} />
            <Column field="phoneNumber" header="Mobile" style={{ width: "250px" }} />
            <Column field="email" header="Email" style={{ width: "300px" }} />
            <Column field="message" header="Message" style={{ width: "500px" }} />
            <Column body={actionBodyTemplate} exportable={false} style={{ width: '10px' }} header="Resume" ></Column>
          </DataTable>
        </div>
      </div>
    </>
  );
};
export default JobApplication;
